import React, { useState, useEffect } from 'react'
import { PropScheduleType, ScheduleContent, ScheduleContentBox } from './getScheduleComponent'
import styled from 'styled-components'
import GeneralTextInput from '../../../../common/components/GeneralTextInput/generalTextInput'
import getCronNextExecution from '../../../../api/getCronNextExecution'
import i18n from 'live/services/i18n'

export function ScheduleCron({ scheduleType, settings, updateSettings }: PropScheduleType): JSX.Element {
    const [cronNextExecution, setCronNextExecution] = useState<{ loading: boolean; nextExecution: string }>({
        loading: false,
        nextExecution: ''
    })

    useEffect(() => {
        if (settings?.cron !== '') {
            setCronNextExecution({ ...cronNextExecution, loading: true })
            getCronNextExecution(settings.cron).then(res => {
                setCronNextExecution({ loading: false, nextExecution: res?.cronNextExecution })
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings?.cron])

    return (
        <ScheduleContent>
            <ScheduleContentBox>
                <StyledGeneralTextInput
                    title={'Schedule Expression'}
                    value={settings?.isRecurrent ? settings?.cron : ''}
                    tooltip={i18n(`
A valid "cron expression" could be, for example,
5 * * * *. The report would be triggered every 5 minutes.
The first number refers to the minutes, the second to the hours, the third to the day (of month), the fourth to the month and the fifth to the day (of week). The '*' character refers to, for example, "every day", "every month" and so on.    

`)}
                    placeholder={i18n('Type a Cron Expression')}
                    required={true}
                    editMode={settings?.isRecurrent}
                    variant={'primary'}
                    onChange={value => {
                        const newJob = { ...settings }
                        newJob.cron = value
                        updateSettings(newJob)
                    }}
                />
                <div
                    className={'scheduling--scheduleInfo__schedulingSection--toggleRecurrence--nextExecution__content'}
                >
                    {cronNextExecution?.nextExecution === '' && settings?.cron !== '' && !cronNextExecution?.loading ? (
                        !settings?.isRecurrent ? (
                            <div>
                                <span>{i18n('Execution at')}:</span> {i18n('invalid cron expression')}
                            </div>
                        ) : (
                            <div>
                                <span>{i18n('Next execution at')}:</span> {i18n('invalid cron expression')}
                            </div>
                        )
                    ) : !settings?.isRecurrent ? (
                        <div>
                            <span>{i18n('Execution at')}:</span> {cronNextExecution?.nextExecution}
                        </div>
                    ) : (
                        <div>
                            <span>{i18n('Next execution at')}:</span> {cronNextExecution?.nextExecution}
                        </div>
                    )}
                </div>
            </ScheduleContentBox>
        </ScheduleContent>
    )
}

const StyledGeneralTextInput = styled(GeneralTextInput)`
    .primary_generalTextInput {
        width: auto;
        &:disabled {
            background: unset;
        }
    }
`
